import { Checkbox, SimpleGrid } from '@mantine/core';
import { useIntl } from 'react-intl';

import styles from './ServicesGrid.module.css';

import type { MessageDescriptor } from 'react-intl';

export type ServicesGridField<T> = {
  key: keyof T;
  label: MessageDescriptor;
};

type ServicesGridProps<T extends Record<string, boolean>> = {
  value: T;
  onChange: (next: T) => void;
  fields: ServicesGridField<T>[];
  disabled?: boolean;
};

/**
 * Reusable, presentational two-column checkbox grid over a record of booleans.
 * Used by the Ship From (pickup) and Ship To (delivery) steps. Purely the grid
 * of checkboxes — any section header / "Save services" toggle lives in the
 * consuming step, not here.
 */
export const ServicesGrid = <T extends Record<string, boolean>>({ value, onChange, fields, disabled }: ServicesGridProps<T>) => {
  const intl = useIntl();

  return (
    <SimpleGrid cols={2} data-testid='services-grid' spacing='sm' verticalSpacing='sm'>
      {fields.map((field) => (
        <Checkbox
          checked={value[field.key]}
          className={styles.checkbox}
          disabled={disabled}
          key={String(field.key)}
          label={intl.formatMessage(field.label)}
          onChange={(event) => onChange({ ...value, [field.key]: event.currentTarget.checked })}
          p='sm'
        />
      ))}
    </SimpleGrid>
  );
};
